




















import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class ProgressBar extends Vue {
  @Prop({ default: '' }) header;
  @Prop({ default: 0 }) value;
}
